import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import { tokens } from "../theme";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import NoDataFound from "./NoDataFound";
import { formatPrice } from "../utils/PriceFormatter";
import { useTheme } from "@emotion/react";

const OnHoldSummaryTable = ({ loading, statusBG, statusData, data, to, onRowClicked }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const renderLoadingOrNoDataView = () => {
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
          <CircularProgress />
        </div>
      );
    } else {
      return <NoDataFound />;
    }
  };

  const getColorForStatus = (status) => {
    const lowerCaseStatus = status.toLowerCase(); // Convert status to lower case
  
    if (lowerCaseStatus.includes('hold')) {
      return colors.grey[300];
    } else if (lowerCaseStatus.includes('release approval')) {
      return colors.grey[200];
    }  else {
      return colors.grey[200]; // Default color if status doesn't match any case
    }
  };

  if (!data || data.length === 0) {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        borderRadius={2}
      >
        <TableContainer sx={{ borderRadius: "0 0 8px 8px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead
              sx={{
                background: "rgba(255,255,255,0.6)",
                color: "#FF2300 !important",
                textTransform: "uppercase",
              }}
            >
              <TableRow sx={{ letterSpacing: "1px" }}>
                <TableCell sx={{ paddingLeft: "28px" }}>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Cut Off</TableCell>
                <TableCell>Payout By</TableCell>
                <TableCell align="right" sx={{ paddingRight: "28px" }}>
                  Payout
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>

        {renderLoadingOrNoDataView()} 
      </Grid>
    );
  }

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} borderRadius={2}>
      <TableContainer sx={{ borderRadius: "0 0 8px 8px" }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead
            sx={{
              backgroundColor: "rgba(255,255,255,0.6)",
              color: "#FF2300 !important",
              textTransform: "uppercase",
            }}
          >
            <TableRow sx={{ letterSpacing: "1px" }}>
              <TableCell sx={{ paddingLeft: "28px" }}>TYPE</TableCell>
              <TableCell>DEALERS</TableCell>
              <TableCell>CYCLES</TableCell>
              <TableCell>TRX TYPE</TableCell>
              <TableCell> # OF TAX</TableCell>
              <TableCell align="right" sx={{ paddingRight: "28px" }}>
              PAYOUT
              </TableCell>
              {/* <TableCell>PAYOUT</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody sx={{ background: "rgba(255,255,255,1)" }}>
            {data.map((list) => (
              <TableRow
                key={list.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  textDecoration: "none !important",
                  cursor: "pointer",
                  '&:hover': {
                    backgroundColor: "#f5f5f5", // change background color on hover
                  },
                }}
                onClick={() => {
                  onRowClicked(
                    list.type,
                    list.showApproval,
                    list.showCancel,
                    list.showHold,
                    list.showRelease,
                    list.showRequestApproval,
                    list.showRequestRelease

                  );
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ paddingLeft: "28px", fontSize: 14, fontWeight: 600 }}
                >
                  {list.type}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  sx={{ paddingLeft: "28px", fontSize: 14, fontWeight: 600 }}
                >
                  {list.dealerCount}
                </TableCell>
               
                 <TableCell>{list.payoutCycleCount}</TableCell>
                 <TableCell>{list.transactionTypeCount}</TableCell>
                <TableCell>{list.transactionCount}</TableCell>
                
                <TableCell
                  align="right"
                  sx={{ paddingRight: "28px", fontSize: 15, fontWeight: 900 }}
                >
                  RM {formatPrice(list.totalPayoutAmount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default OnHoldSummaryTable;
